<template>
    <div class="login">
        <div class="outer" v-if="isLogin">
            <div class="img-div-outer">
                <img :src="require('@/assets/logo/outer.png')" alt />
                <div class="inner text-center" :class="setMarginTop?'inner1':''">
                    <!-- <el-button
                            size="mini"
                            type="primary"
                            class="btn-center btn-class"
                            @click="ysLoginF()"
                        >医师登录</el-button> -->
                    <el-tabs v-model="activeName" @tab-click="handleClick" class="my-tab" stretch>
                       <el-tab-pane label="账号登录" name="first" class="login-div">
                           <el-form ref="form" :model="form" :rules="rules">
                               <el-form-item prop="temp">
                                   <el-input
                                       placeholder="手机号/身份证号/邮箱"
                                       v-model="form.temp"
                                       class="first-input my-input"
                                   ></el-input>
                               </el-form-item>
                               <el-form-item prop="password">
                                   <el-input
                                       placeholder="密码"
                                       v-model="form.password"
                                       class="second-input my-input"
                                       type="password"
                                       @keyup.enter.native="submitFunc('form')"
                                   ></el-input>
                               </el-form-item>
                               <el-form-item class="zcmm">
                                   <span
                                       style="color: #f64420;"
                                       @click="register()"
                                       class="fl shou"
                                   >立即注册</span>
                                   <span @click="forgetP()" class="fr shou">忘记密码?</span>
                               </el-form-item>
                               <p class="margin20">
                                   <el-checkbox class="login-form__tos" v-model="checked"></el-checkbox>
                                   <span class="tip">
                                       已阅读并同意
                                       <a href="#" @click="getUser()">《用户服务协议》</a>和
                                       <a href="#" @click="getYiSi()">《隐私策略》</a>
                                   </span>
                               </p>

                               <el-form-item>
                                   <button
                                       class="btn-center login-button"
                                       type="button"
                                       @click="submitFunc('form')"
                                   >用户登录</button>
                               </el-form-item>
                               <el-form-item>
                                   <el-row>
                                       <el-col :span="16">
                                           <div class="other">
                                               其他登录方式：
                                               <img
                                                   src="../assets/logo/weixin.png"
                                                   alt
                                                   class="weixin"
                                                   @click="weixinLogin()"
                                               />
                                           </div>
                                       </el-col>
                                        <!-- <el-col :span="8">
                                           <el-button
                                               size="mini"
                                               type="primary"
                                               class="btn-center btn-ys"
                                               @click="ysLoginF()"
                                           >医师登录</el-button>
                                       </el-col>  -->
                                   </el-row>
                               </el-form-item>
                           </el-form>
                       </el-tab-pane>
                       <!-- <el-tab-pane label="手机验证" name="second1" class="login-div">
                           <el-form ref="form1" :model="form1" :rules="rules1">
                               <el-form-item prop="phone">
                                   <el-input
                                       placeholder="手机号"
                                       v-model="form1.phone"
                                       class="first-input my-input"
                                   ></el-input>
                               </el-form-item>
                               <el-form-item prop="yzm">
                                   <el-input placeholder="验证码" v-model="form1.yzm" class="yzm">
                                       <el-button
                                           slot="append"
                                           :disabled="disabledyzm"
                                           @click="getYZMF()"
                                       >{{btntxt}}</el-button>
                                   </el-input>
                               </el-form-item>
                               <el-form-item>
                                   <span
                                       style="color: #f64420;"
                                       @click="register()"
                                       class="fl"
                                   >立即注册</span>
                               </el-form-item>

                               <p class="margin20">
                                   <el-checkbox class="login-form__tos" v-model="checked1"></el-checkbox>
                                   <span class="tip">
                                       已阅读并同意
                                       <a href="#" @click="getUser()">《用户服务协议》</a>和
                                       <a href="#" @click="getYiSi()">《隐私策略》</a>
                                   </span>
                               </p>

                               <el-form-item>
                                   <button
                                       class="btn-center login-button"
                                       type="button"
                                       @click="submitFunc1('form1')"
                                   >用户登录</button>
                               </el-form-item>
                           </el-form>
                       </el-tab-pane> -->


<!-- 这个按钮以后要改 -->
                        
                      <!-- <el-tab-pane label="身份证登录" name="second" class="login-div">
                        <el-form ref="form1" :model="form1" :rules="rules1">
                          <el-form-item prop="username">
                            <el-input
                              placeholder="姓名"
                              v-model="form1.username"
                              class="first-input my-input"
                            ></el-input>
                          </el-form-item>
                          <el-form-item prop="idCard">
                            <el-input
                              placeholder="身份证号码"
                              v-model="form1.idCard"
                              class="first-input my-input"
                            ></el-input>

                          </el-form-item>
                          <el-form-item>
                                    <span
                                      style="color: #f64420;"
                                      @click="register()"
                                      class="fl"
                                    >立即注册</span>
                          </el-form-item>

                          <p class="margin20">
                            <el-checkbox class="login-form__tos" v-model="checked1"></el-checkbox>
                            <span class="tip">
                                        已阅读并同意
                                        <a href="#" @click="getUser()">《用户服务协议》</a>和
                                        <a href="#" @click="getYiSi()">《隐私策略》</a>
                                    </span>
                          </p>

                          <el-form-item>
                            <button
                              class="btn-center login-button"
                              type="button"
                              @click="submitFunc1('form1')"
                            >用户登录</button>
                          </el-form-item>
                        </el-form>
                      </el-tab-pane> -->
                    </el-tabs>
                </div>
            </div>
        </div>
        <el-row>
            <el-col>
                <el-dialog
                    :title="title"
                    :visible.sync="centerDialogVisible"
                    width="60%"
                    center
                    class="mianUser"
                >
                    <div v-html="content"></div>
                    <span slot="footer" class="dialog-footer">
                        <el-button type="primary" @click="centerDialogVisible = false">同 意</el-button>
                    </span>
                </el-dialog>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="centerDialogVisible1" class="erweimaDialog" width="30%" center>
            <iframe :src="erweimaUrl" frameborder="0" class="erweimaIframe"></iframe>
        </el-dialog>
    </div>
</template>

<script>
import rules from "@/common/rules";
import {
		mapMutations
	} from 'vuex';
export default {
    name: "login",
    data() {
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else {
                if (this.formR.spassword !== "") {
                    // this.$refs.user.validateField("checkPass");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value !== this.formR.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            // 账号登陆验证
            rules: {
                password: [
                    {
                        required: true,
                        message: "请输入密码",
                        trigger: "blur"
                    }
                ],
                temp: [
                    {
                        required: true,
                        message: "请输入手机号、身份证号或邮箱",
                        trigger: "blur"
                    }
                ]
            },
            // 短信登陆验证
            rules1: {
                yzm: [
                    {
                        required: true,
                        message: "请输入验证码",
                        trigger: "blur"
                    }
                ],
                phone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur"
                    },
                    {
                        validator: rules.FormValidate.Form().validatePhone,
                        trigger: ["blur", "change"]
                    }
                ]
            },
            activeName: "first",
            // 账号登陆表单
            form: {
                temp: "",
                password: ""
            },
            // 短信登陆表单
            form1: {
                phone: "",
                yzm: ""
            },
            rules2: {
                password: [{ validator: validatePass, trigger: "blur" }],
                spassword: [{ validator: validatePass2, trigger: "blur" }],

                username: [
                    {
                        validator: rules.FormValidate.Form().validatePhone,

                        trigger: ["blur", "change"]
                    }
                ]
            },
            formR: {
                username: "",
                password: "",
                spassword: ""
            },
            isLogin: true,
            setMarginTop: false,
            btntxt: "获取验证码",
            disabledyzm: false,
            time: 60,
            checked: true,
            checked1: true,
            centerDialogVisible: false,
            title: "",
            content: "",
            centerDialogVisible1: false,
            erweimaUrl: ""
        };
    },
    watch: {
        $route(to, from) {
            //监听路由是否变化
            console.log(this.$route.query.zhuce);
            if (this.$route.query.zhuce) {
                //判断id是否有值
                //调数据
                this.isLogin = false;
                this.setMarginTop = true;
            } else {
                this.isLogin = true;
                this.setMarginTop = false;
            }
        }
    },
    methods: {
        ...mapMutations(['login']),
        handleClick(tab, event) {
          console.log('tab', tab)
            if (tab.index != 0) {
                this.setMarginTop = true;
            } else {
                this.setMarginTop = false;
            }
        },
        //忘记密码
        forgetP() {
            this.$router.push({ path: "/forgetP" });
        },
        // 注册
        register() {
            this.$router.push({ path: "/register" });
        },
        // 账号登陆
        submitFunc(form) {
            let that = this;
            that.$refs[form].validate(valid => {
                if (valid) {
                    let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
                    let emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
                    const idCardRegex18 =
                        /^[1-9]\d{5}(18|19|20|21|22)?\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}(\d|[Xx])$/;
                    const idCardRegex15 = /^([1 - 9]\d{7}((0[1 - 9])|(10|11|12))(([0 - 2][1 - 9])|10|20|30|31)\d{3})$/;
                    if (
                        phoneReg.test(that.form.temp) ||
                        emailReg.test(that.form.temp)||
                        idCardRegex18.test(that.form.temp)||
                        idCardRegex15.test(that.form.temp)
                    ) {
                    } else {
                        that.$message.error("请输入正确的手机号、身份证号或邮箱");
                        return false;
                    }
                    if (!this.checked) {
                        that.$message({
                            type: "warning",
                            message: "请阅读《用户服务协议》和《隐私策略》"
                        });
                        return false;
                    }
                    let url = "/user/loginPhoneOrIdCardOrEmail";
                    let params = {
                        temp: that.form.temp,
                        password: that.form.password,
                        ys: false
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                            if (res.data.code == 200) {
                                let arr = res.data.data;
                                sessionStorage.clear();
                                sessionStorage.setItem("token", arr.token);
                                sessionStorage.setItem("YS", false);
                                this.login(arr);
                                if (localStorage.getItem("loginBeforeUrl")) {
                                    window.location.href = localStorage.getItem(
                                        "loginBeforeUrl"
                                    );
                                    localStorage.removeItem("loginBeforeUrl");
                                } else {
                                    that.$router.replace({
                                        path: "/index"
                                    });
                                }
                                // 刷新兄弟组件
                                let NewPage =
                                    "_empty" +
                                    "?time=" +
                                    new Date().getTime() / 500;
                                this.$router.push(NewPage);
                                this.$router.go(-1);
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        })
                        .catch(() => {
                            
                        });
                }
            });
        },
        ysLoginF() {
            this.$router.replace({
                path: "/ysLogin"
            });
        },
        // 手机验证登陆
        submitFunc1(form1) {
            let that = this;
            that.$refs[form1].validate(valid => {
                if (valid) {
                    if (!this.checked1) {
                        that.$message({
                            type: "warning",
                            message: "请阅读《用户服务协议》和《隐私策略》"
                        });
                        return false;
                    }
                    let url = "/user/loginNew";
                    let params = {
                      username: that.form1.username,
                      idCard: that.form1.idCard,
                    };
                    that.$http
                        .post(url, params)
                        .then(res => {
                            if (res.data.code == 200) {
                                let arr = res.data.data;
                                sessionStorage.clear();
                                sessionStorage.setItem("token", arr.token);

                                sessionStorage.setItem("YS", false);
                                sessionStorage.setItem(
                                    "userInfo",
                                    JSON.stringify(arr)
                                );
                                this.login(arr);
                                if (localStorage.getItem("loginBeforeUrl")) {
                                    window.location.href = localStorage.getItem(
                                        "loginBeforeUrl"
                                    );
                                    localStorage.removeItem("loginBeforeUrl");
                                } else {
                                    that.$router.replace({
                                        path: "/index"
                                    });
                                }
                                // 刷新兄弟组件
                                let NewPage =
                                    "_empty" +
                                    "?time=" +
                                    new Date().getTime() / 500;
                                this.$router.push(NewPage);
                                this.$router.go(-1);
                            } else {
                                that.$message.error(res.data.msg);
                            }
                        })
                        .catch(() => {
                            // that.$message.error("网络错误！");
                        });
                }
            });
        },
        // 获取验证码
        getYZMF() {
            let that = this;
            if (!that.form1.phone) {
                that.$message.error("请先输入手机号");
                return false;
            }
            let url = "/sms/sendMessageToLogin";
            let params = {
                phone: that.form1.phone
            };
            that.$http
                .post(url, params)
                .then(res => {
                    if (res.data.code == 200) {
                        that.$message({
                            message: "验证码发送成功",
                            type: "success"
                        });
                        that.disabledyzm = true;
                        that.timeryzm();
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message.error("网络错误！");
                });
        },

        // 微信登陆
        weixinLogin() {
            let that = this;
            let url = "wxLogin/qrconnect";
            that.$http
                .post(url)
                .then(res => {
                    if (res.data.code == 200) {
                        sessionStorage.setItem("YS", false);
                        that.centerDialogVisible1 = true;
                        that.erweimaUrl = res.data.data;
                        // window.location.href = res.data.data;
                    } else {
                        that.$message.error(res.data.msg);
                    }
                })
                .catch(() => {
                    that.$message("网络错误！");
                });
        }
    },
    created() {
        let that = this;
        if (sessionStorage.getItem("userInfo")) {
            this.userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
            if (JSON.parse(sessionStorage.getItem("YS"))) {
                console.log('医师');
                that.$router.replace({
                    path: "/personalFiles"
                });
            } else {
                console.log('用户');
                that.$router.replace({
                    path: "/index"
                });
            }
        }
        if (!!that.$route.query.zhuce) {
            that.isLogin = false;
            that.setMarginTop = true;
        }
    }
};
</script>

<style scoped>
.btn-class{
    background: #f64320;
    border: #f64320;
    position: relative;
    /*top:10px;*/
    left:100px;
    z-index: 100;
}
.set-margin {
    margin-top: 20px;
}
.two {
    font-size: 14px;
    padding-bottom: 20px;
    cursor: pointer;
}
.login {
    background: url(../assets/logo/bg.jpg) no-repeat center center;
}

.outer {
    padding: 50px 0px;
    height: 415px;
    /* background: url(../assets/logo/outer.png) no-repeat center center; */
    position: relative;
    margin: 0 auto;
}
.img-div-outer {
    width: 814px;
    margin: 0 auto;
    position: relative;
}
.inner {
    position: absolute;
    top: 35px;
    right: 4%;
    width: 290px;
}
/* .inner1 {
    top: 65px;
} */
.login-button {
    width: 100%;
    height: 46px;
    background-color: #f64320;
    border-radius: 2px;
    color: #fff;
    border: 1px solid #f64320;
}
.login-button:focus {
    border: 1px solid #f64320 !important;
}
.weixin {
    display: inline-block;
    vertical-align: middle;
}
.refresh-icon {
    background-color: #fff !important;
}
.tip {
    font-size: 12px;
}
.zcmm {
    margin-bottom: 0px;
}
.other{
    text-align: left;
}
.other img{
    width: 25px;
    height: 25px;
}
.btn-ys{
    float: right;
    margin-top: 6px;
    background-color: #f64320;
    border: #f64320;
}

</style>
<style>
.erweimaDialog .el-dialog--center .el-dialog__body {
    text-align: center;
    height: 400px;
}
.erweimaIframe {
    height: 400px;
}
.el-tabs--bottom .el-tabs__item.is-bottom:last-child, .el-tabs--bottom .el-tabs__item.is-top:last-child, .el-tabs--top .el-tabs__item.is-bottom:last-child, .el-tabs--top .el-tabs__item.is-top:last-child{
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/login.vue